import { renderAlert } from "../../CommonComponents/Alert/Alert.jsx";
import { createUserActivityTemplate } from "../../helpers/helperFunctionTypeScript.ts";
import { GET, PATCH, POST } from "../../service/axiosMethods.js";
import { ELASTIC_URL } from "../../utils/apiConstant.js";
import store from "../store.js";
import ACTION_TYPES from "../types.js";
import { v4 as uuidv4 } from 'uuid';

export const uploadNotesToSheet = ({ selectedSheetId, selectedRow, selectedCell, updatedNotesTimeStamp }) => async (dispatch) => {
    try {
        let { currentSelectedSheet: sheetId } = store.getState().sheetReducer
        sheetId = selectedSheetId || sheetId.id
        let storageNotes = localStorage.getItem(`sheetNotes${sheetId}`)
        if (!storageNotes) return
        let notes = store.getState().userActivityReducer.sheetNotes
        if (notes != storageNotes) {
            let note = storageNotes
            await POST(`${ELASTIC_URL}/sheet/uploadNotesToSheet`, { note, sheetId: sheetId,updatedNotesTimeStamp: updatedNotesTimeStamp});
            dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, sheetNotes: storageNotes })
        }

    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const uploadNotesToCell = ({ selectedSheetId, selectedRow, selectedCol, sheetId }) => async (dispatch) => {
    try {
        let storageNotes = !selectedCol ? localStorage.getItem('rowNotes') : localStorage.getItem('cellNotes')
        if (!storageNotes) return
        let { cellNotes, rowNotes, selectedCell, selectedRow } = store.getState().userActivityReducer

        if (!selectedCol) {
            if (rowNotes != storageNotes) {
                let note = storageNotes
                return { rowId: selectedRow, row: { notes: note } }
                // const res = await PATCH(`${ELASTIC_URL}/sheetrow/updateRowNotes`, {sheetrowid:selectedRow,notes:note,sheetId });
                // dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, rowNotes: storageNotes })
            }
        }
        else if(selectedCol){
            if (cellNotes!= storageNotes) {
                let note = storageNotes
                return {rowId: selectedCell.rowId ,cell: { notes: note } }
            }
        }

    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}

export const getNotifications = (user,workspace,collaboration,page,pageSize,sortBy,filterBy) => async (dispatch) => {
    try {
        const responseNotifications = await POST(`/notification/getNotifications/`, { recipient_id: user.email, workspace: workspace, collaboration: collaboration });
        
        if (responseNotifications && responseNotifications.data) {
            const notificationsMap = new Map();
            responseNotifications.data.forEach(notification => {
                notificationsMap.set(notification.notification_id, notification);
            });
            if (notificationsMap) dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, notifications: notificationsMap})
        }

    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const getSharedByMeNotifications = (user, workspace, collaboration) => async (dispatch) => {
    try {
        const res = await POST(`/notification/getSharedByMeNotifications/`, { sender_id: user.email, workspace: workspace, collaboration: collaboration });

        if (res.status === 201) {
            const sharedByMeNotificationsMap = new Map();
            res.data.forEach(notification => {
                sharedByMeNotificationsMap.set(notification.notification_id, notification)
            })
            if (sharedByMeNotificationsMap)
                dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, sharedByMeNotifications: sharedByMeNotificationsMap })
        }
    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const getUserAccessInfo = (user, workspace, collaboration,openSheetCallback) => async (dispatch) => {
    try {
        const response = await POST(`/access/getAccessInfo/`, { recipient_id: user.email, workspace: workspace, collaboration: collaboration });
        const response2 = await POST(`/access/getAccessInfo/`, { sender_id: user.email, workspace: workspace, collaboration: collaboration });
        if (response && response.data && response2 && response2.data) {
            const accessInfoMap = new Map();
            response.data.forEach(accessInfo => {
                accessInfoMap.set(accessInfo.id, accessInfo)
            })
            response2.data.forEach(accessInfo => {
                accessInfoMap.set(accessInfo.id, accessInfo)
            })
            if (accessInfoMap){
                dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, accessInfo: accessInfoMap })
                if(openSheetCallback) openSheetCallback()
            }
        }
    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const deleteNotifications = (notificationID, notifications) => async (dispatch) => {
    try {
        const responseNotifications = await POST(`/notification/deleteNotifications/`, { notification_id: notificationID });
        notifications.delete(notificationID)
        let updatedNotifications = new Map(notifications)
        if (responseNotifications && responseNotifications.data) {
            renderAlert("Notification Deleted", 'success', 2000)
            dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, notifications: updatedNotifications })
        }

    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}

export const revokeAccess = (accessId, accessInfo,callback) => async (dispatch) => {
        const responseAccess = await POST(`access/deleteAccess/`, { access_id: accessId });
        if (responseAccess.status === 201) {
            callback()
        }
        accessInfo.delete(accessId);
        const accessInfoById=store.getState().userActivityReducer.accessInfoById
        let updateAcessInfoById= accessInfoById.filter(item=>item.id!==accessId)
        let updatedAccess = new Map(accessInfo)
        dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, accessInfo: updatedAccess,accessInfoById:updateAcessInfoById })
}

export const updateAccessInStore = (accessId) => async(dispatch) => {
    try {
        const {accessInfo} = store.getState().userActivityReducer;
        const updatedAccessInfo = new Map(accessInfo);
        updatedAccessInfo.delete(accessId);
        dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, accessInfo: updatedAccessInfo })
    } catch (error) {
        console.log("Error in updateAccessInStore in userActivity  Action", error);
    }
}

export const ShareSheet = async (sheet, userToReceive, message, view, accessLevel, callback) => {
    try {
        let newNotification = {}
        const { userData } = store.getState().userReducer
        newNotification.notification_id = uuidv4()
        newNotification.recipient_id = userToReceive.email;
        newNotification.sender_id = userData.email;
        newNotification.entity_id = sheet.id
        newNotification.receiver_name = userToReceive.username
        if (userToReceive.email === userData.email) {
            renderAlert("Sheet can't be shared with the same person which is signed In", 'error')
            return
        }
        newNotification.message = message;
        newNotification.timestamp = new Date(); // Set the timestamp to the current date/time
        newNotification.notification_type = 'Shared';
        newNotification.status = 'Not read';
        newNotification.view = view;
        newNotification.accesslevel = accessLevel;

        let metaData = {
            sheet_id: sheet.id, sheetName: sheet.name, sheet_identifier: sheet.sheet_identifier, username: userData.name
        }
        newNotification.metadata = JSON.stringify(metaData)
        const response = await POST(`/notification/register/`, newNotification);
        if (response.status === 201) {
            callback("success")
        }
        else {
            callback("error")
        }

    } catch (error) {
        callback(error)
        console.log("error in sharing sheet", error);
    }
}

export const revokeAccessNotification = (notification,metadata) => async () => {
        let newNotification = {}
        const { userData } = store.getState().userReducer
        newNotification.notification_id = uuidv4()
        newNotification.recipient_id = notification.recipient_id||notification.user_id;
        newNotification.sender_id = userData.email;
        newNotification.entity_id = notification.entity_id;
        newNotification.receiver_name = notification.receiver_name
        newNotification.message = 'Access revoked by owner';
        newNotification.timestamp = new Date(); // Set the timestamp to the current date/time
        newNotification.notification_type = 'Revoke Access';
        newNotification.status = 'Not read';
        newNotification.view = notification.view;
        newNotification.accesslevel = notification.accessLevel;
        newNotification.metadata = notification.metadata||metadata
        const response = await POST(`/notification/register/`, newNotification);
        if (response.status === 201) {
            renderAlert('Access Revoked successfully and User notified', 'success', 2000)
        }
    }

export const updatedNotificationinDB = (notifications, notificationId, isRead = false) => async (dispatch) => {
    try {
        let notification = notifications.get(notificationId)
        let notificationforDB = { notification_id: notificationId, status: 'read' }
        if (isRead) {
            notificationforDB = { notification_id: notificationId, status: 'Not read' }
        }
        const responseNotifications = await POST(`/notification/updatedNotificationinDB/`, { notification: notificationforDB });
        notification.status = 'read';
        if (isRead) {
            notification.status = 'Not read';
        }
        notifications.set(notificationId, notification)
        let updatedNotifications = new Map(notifications)
        dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, notifications: updatedNotifications })
    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const markAllNotificationAsRead = (recipient_id, notifications, isReload = true) => async (dispatch) => {
    try {
        if (isReload) {
            const res = await POST('/notification/markAllasRead', { recipient_id: recipient_id })
        }
        if (!isReload) {
            const keys = Array.from(notifications.keys())
            const updatedNotifications = new Map(keys.map((key) => [key, { ...notifications.get(key), status: "read" }]))
            dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, notifications: updatedNotifications })
        }
    }
    catch (e) {
        console.log("error in marking all the notifications read", e)
    }
}
export const makeuserSessionActive = async (user, sessionID) => {
    try {
        const response = await POST(`/user/makeUserSessionActive/`, { user: user.email, sessionID: sessionID });
        if (response && response.data) sessionStorage.setItem('sessionID', response.data)
    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const checkifSessionIsActive = async (user) => {
    try {
        let sessionID = uuidv4()
        // sessionStorage.setItem('sessionID',sessionID)
        const response = await POST(`/user/checkifSessionIsActive/`, { user: user.email });
        if (response && response.data) {
            if (response.data === true) {
                //handling prompt
                const result = window.confirm('Another session is active . Do you want to logout from all and proceed with this ?');
                if (result) {
                    // Code to execute when OK is clicked                  
                    const response = await POST(`/user/removeOldSessions/`, { user: user.email, sessionID: sessionID });
                    if (response && response.data) sessionStorage.setItem('sessionID', response.data)
                } else {
                    // Code to execute when Cancel is clicked or dialog is dismissed
                    removeUserSession(user, sessionID)
                }
            }
            else makeuserSessionActive(user, sessionID)
        }
        else makeuserSessionActive(user, sessionID)
    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}


export const removeUserSession = async (user, sessionID) => {
    try {
        sessionStorage.clear()
        const response = await POST(`/user/removeUserSession/`, { user: user.email, sessionID: sessionID });
    } catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const getAccessFromDB = async (sheet_id, user_id) => {
    try {
        const response = await POST(`/access/getAccessofUserforSheetFromDB/`, { recipient_id: user_id, entity_id: sheet_id });
        if (response.data && response.data.length > 0) {
            return response.data[0]
        }
        else {
            renderAlert('You do not have access to this sheet', 'error', 60000)
            return ''
        }
    }
    catch (error) {
        console.log("errror in getting sheet data from API", error)
    }
}
export const addEvent = (event, calendarEvents) => async (dispatch) => {
    try {
        const apolloGraphQlClient = (await import('../../GraphQL/DataAccessGraphQLClient.js')).default
        const { CREATE_EVENT } = await import('../../GraphQL/Queries.js')
        const { data } = await apolloGraphQlClient.mutate({ mutation: CREATE_EVENT, variables: { event: event } })
        if (data && data.createEvent) {
            data.createEvent.start=new Date(data.createEvent.start)
            data.createEvent.end=new Date(data.createEvent.end)
            let tempEvents = [...calendarEvents]
            tempEvents.push(data.createEvent)
            dispatch({ type: ACTION_TYPES.SET_CALENDAR_EVENTS, payload: tempEvents })
        }
    }
    catch (e) {
        console.log(e)
    }
}
export const checkIfUserisSignedInOnOneDrive = () => async (dispatch) => {

    try {
        const res = await POST(`/onedrive/checkIfUserIsSignedIn`, {});
        if (res && res.data === true) {
            dispatch({
                type: ACTION_TYPES.SET_USER_ACTIVITY_INFO,
                isOneDriveConnected: true,
            });
        } else {
            dispatch({
                type: ACTION_TYPES.SET_USER_ACTIVITY_INFO,
                isOneDriveConnected: false,
            });
            renderAlert('Not connected to OneDrive', "info")
        }
    } catch (error) {
        console.error('Error checking OneDrive status', error);
        renderAlert('Not connected to OneDrive', "info")
        dispatch({
            type: ACTION_TYPES.SET_USER_ACTIVITY_INFO,
            isOneDriveConnected: false,
        });
    }
}

export const checkIfUserisSignedInAzureDevOps = () => async (dispatch) => {

    try {
        const res = await GET(`/devops/checkConnected`, {});
        if (res && res.data === true) {
            dispatch({
                type: ACTION_TYPES.SET_ISAZUREDEVOPS_CONNECTED,
                isAzureDevOpsConnected: true,
            });
        } else {
            dispatch({
                type: ACTION_TYPES.SET_ISAZUREDEVOPS_CONNECTED,
                isAzureDevOpsConnected: false,
            });
        }
    } catch (error) {
        console.error('Error checking AzureDevOps status', error);
        dispatch({
            type: ACTION_TYPES.SET_ISAZUREDEVOPS_CONNECTED,
            isAzureDevOpsConnected: false,
        });
    }
}

export const getAllEvents = (userEmail) => async (dispatch) => {
    try {
        const apolloGraphQlClient = (await import('../../GraphQL/DataAccessGraphQLClient.js')).default
        const { GET_ALL_EVENTS_OF_USER } = await import('../../GraphQL/Queries.js')
        const { data } = await apolloGraphQlClient.query({ query: GET_ALL_EVENTS_OF_USER, variables: { user_email: userEmail } })
        if (data && data.getAllEvents) {
            let temp=data.getAllEvents
            let payload=temp.map(item=>{
                let start=new Date(item.start)
                let end=new Date(item.end)
                return {...item,start:start,end:end}
            })
            dispatch({ type: ACTION_TYPES.SET_CALENDAR_EVENTS, payload: payload })
        }
    }
    catch (e) {
        console.log(e)
    }
}
export const updateEvent = (id, updatedEvent) => async (dispatch) => {
    try {
        const calendarEvents=store.getState().userActivityReducer.calendarEvents
        const apolloGraphQlClient = (await import('../../GraphQL/DataAccessGraphQLClient.js')).default
        const { UPDATE_EVENT } = await import('../../GraphQL/Queries.js')
        delete updatedEvent.id
        const { data } = await apolloGraphQlClient.mutate({ mutation: UPDATE_EVENT, variables: { id: id, updatedEvent: updatedEvent } })
        if (data && data.updateEvent) {
            let tempEvents = calendarEvents.map(item => {
                if(item.id===id){
                    let start=new Date(data.updateEvent.start)
                    let end=new Date(data.updateEvent.end)
                    data.updateEvent={...data.updateEvent,start:start,end:end,completed:data.updateEvent.completed}
                    return data.updateEvent
                }
                else return item
            })
            dispatch({ type: ACTION_TYPES.SET_CALENDAR_EVENTS, payload: tempEvents })
        }
    }
    catch (e) {
        console.log(e)
    }
}
export const deleteEvent = (eventId,calendarEvents) => async (dispatch) => {
    try {
        const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
        const {DELETE_EVENT}=await import('../../GraphQL/Queries.js')
        const {data}=await apolloGraphQlClient.mutate({mutation:DELETE_EVENT,variables:{eventId:eventId}})
        if (data.deleteEvent) {
            let tempEvents=calendarEvents.filter(item=>item.id!==eventId)
            dispatch({ type: ACTION_TYPES.SET_CALENDAR_EVENTS, payload: tempEvents })
        }
    }
    catch (e) {
        console.log(e)
    }
}
export const getAccessInfoByEntityId=(entity_id)=>async (dispatch)=>{
    try{
        const res = await POST(`/access/getAccessByEntityId/`, { entity_id: entity_id });
        if(res && res.data)
        {
            dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, accessInfoById: res.data })
            return res.data;
        }
    }
    catch(e)
    {
        console.log(e)
    }
}

export const setAccessByEntityId = (accessArray) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, accessInfoById: accessArray })
}

export const getAccessInfoByEntityIdFprManageAccess = async (entity_id) => {
    try {
        const res = await POST(`/access/getAccessByEntityId/`, { entity_id: entity_id });
        if (res && res.data) {
            return res.data;
        }
    }
    catch (e) {
        console.log(e)
    }
}

export const getAccessInfoByEntityIdForSharedSheet=(entity_id)=>async (dispatch)=>{
    try{
        const res = await POST(`/access/getAccessByEntityId/`, { entity_id: entity_id });
        if(res&&res.data)
        {
            dispatch({ type: ACTION_TYPES.SET_SHARED_SHEET_ACCESS, accessInfoByIdForSharedSheet: res.data })
            return res.data;
        }
    }
    catch(e)
    {
        console.log(e)
    }
}

export const doesSharedSheetExistsOnOneDrive = (sheet_id, name) => async (dispatch) => {
    try {
        const { isSharedWorkbook } = store.getState().workbookReducer;
        const { isOneDriveConnected } = store.getState().userActivityReducer;
        if (isOneDriveConnected) {
            const resp = await POST(`/onedrive/doesSharedSheetExistOnOneDrive`, { sheet_id: sheet_id, sheet_name: name });
            if ((resp.data != undefined || resp.data !== null) && resp.data === false && !isSharedWorkbook) {
                dispatch({ type: ACTION_TYPES.SET_FLAGTOUPDATESHEETONONEDRIVE, updateSheetOfWorkbookOnOnedrive: true });
            }
        }
    } catch (e) {
        console.log('Error checking sharedSheetExists on Onedrive ', e);

    }
}

export const oneDriveLogout=async()=>{
    const res =await GET(`/onedrive/oneDriveLogout`);
    return res
}

export const getWorkbooksSyncedWIthOneDrive=(workbooks)=>async (dispatch)=>{
    let {isOneDriveConnected}=store.getState().userActivityReducer
    if(!isOneDriveConnected) return
    const res =await POST(`/onedrive/getWorkbooksSyncedWIthOneDrive`,workbooks);
    if(res &&  res.data){
        let syncedWorkbooks={}
        res.data.forEach((wb)=>syncedWorkbooks[wb.workbookid]=true)
        dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, workbooksSyncedWithOneDrive:syncedWorkbooks })
    }
}

export const fetchSignedUrl = async (key, fileName, file, setDownloadProgress) => {
    const url = file.online ? file.url : `/file/download-attachment?key=${key}&fileName=${fileName}`;

    try {
        setDownloadProgress(25);
        let responseData
        if (!file.online) {
            const response = await GET(url);
            if (!response.data) {
                throw new Error('Network response was not ok');
            }
            responseData = response.data.message;
            setDownloadProgress(50);
        }
        else {

            let response = await POST(`/onedrive/getFileUrlForPreview`, { fileUrl: key });
            if (!response.data) {
                throw new Error('Network response was not ok');
            }
            responseData = response.data;
            setDownloadProgress(50)
        }

        const fileResponse = await GET(responseData.signedUrl, {
            responseType: 'blob',
        });
        
        setDownloadProgress(75);
       // as status is coming 200 so no need to check further
        // if (!fileResponse.ok) {
        //     throw new Error('Failed to fetch the file from S3');
        // }
        const blob = fileResponse.data;
        setDownloadProgress(100);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = responseData.fileName || fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        renderAlert('Attachment downloaded', "success");

        setTimeout(() => {
            setDownloadProgress(120)
        }, 600);


    } catch (error) {
        console.error('Failed to download attachment:', error);
        renderAlert('Failed to download attachment', "error");
        setDownloadProgress(0); // Reset progress on error
    }
};

  
export const deleteAttachment=async(key,fileName) =>{
    const res= await GET(`/file/delete-attachment?key=${key}`)
    if(res && res.data) return res.data
}

export const deleteEventsOnDeleteSheet = (sheetid,calendarEvents)=> async (dispatch) =>{
    try{
        const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
        const {DELETE_EVENTS_ON_DELETESHEET}=await import('../../GraphQL/Queries.js')
        const response=await apolloGraphQlClient.mutate({mutation:DELETE_EVENTS_ON_DELETESHEET,variables:{sheetid:sheetid}})
        if(response){
            let updatedEventsList=calendarEvents.filter((item)=>{
                if (!item.sheetid) {
                    return true;
                  }
                  // Include events whose sheetid is not equal to sheet.id
                  return item.sheetid !== sheetid;})
            dispatch({ type: ACTION_TYPES.SET_CALENDAR_EVENTS, payload: updatedEventsList })
            renderAlert('Events for sheet deleted successfully','success',1000)
        }
    }
    catch(err){
        console.log(err)
        renderAlert('Error Deleting events, Please try again.','error',2000)
    }
}
export const uploadWorbookToOneDriveIfNotAlready = (workbook_id, workbook) => async (dispatch) => {
    try{
        let { currentSelectedWorkbook, currentDownladingWorkbook, exportWorkbook } = store.getState().workbookReducer;
        const { takeOneDriveBackup, isOneDriveConnected } = store.getState().userActivityReducer;
        const {userData}= store.getState().userReducer;
        const isSharedWb = workbook?.user_email !== userData.email;
        const isExportingAlreadyOngoing = (takeOneDriveBackup && ((currentDownladingWorkbook && Object.keys(currentDownladingWorkbook).length > 0) || (exportWorkbook && Object.keys(exportWorkbook).length > 0)))
        
        let isPresent = await POST(`/onedrive/doesWorkbookExistOnOneDrive`, { 
            workbook_id, 
            workbook_name: currentSelectedWorkbook.name,
            issharedworkbook : isSharedWb,
            user_email : userData.email
        });

        if (isPresent.data === false && !isExportingAlreadyOngoing && isOneDriveConnected) {
            dispatch({ type: ACTION_TYPES.DOWNLOAD_WORKBOOK, currentDownladingWorkbook: workbook })
            dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, takeOneDriveBackup: true })
        }
    }
    catch(err){
        console.log('error: ' + err);        
    }
}


export const addSharedList = async(list) =>  {
    try {
       const saveSharedList = await POST(`${ELASTIC_URL}/shared-list/register`,list)
    }
    catch (e) {
        console.log('Error will saving sharedList ',e)
    }
}

export const getSharedLists=async(user_email)=>{
    try {
        const sharedLists=await POST(`${ELASTIC_URL}/shared-list/getSharedLists`,user_email)
        return sharedLists;
        
    } catch (error) {
        console.log('Error fetching shared lists ',error);
        
    }
}

export const getSharedListById=async(id)=>{
    try {
        const sharedList=await POST(`${ELASTIC_URL}/shared-list/getSharedListById`,id)
        return sharedList;
        
    } catch (error) {
        console.log('Error fetching shared list by id ',error);
        
    }
}

export const setSharedListsInStore = (list) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, sharedLists: list })
}

export const fetchSharedLists = async (user) => {
    const allSharedLists = await getSharedLists({ user_email: user });
    return allSharedLists.data;
}

const fetchFileAsBlob = async (fileUrl) => {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
};

export const getURLForAttachment = async (key, fileName, file, callback) => {
    if (file.online) {
        let response = await POST(`/onedrive/getFileUrlForPreview`, { fileUrl: key });
        if (!response.data) {
            throw new Error('Network response was not ok');
        }
        let data = response.data
        if (data.fileType == 'application/pdf') {
            let blobUrl = await fetchFileAsBlob(data.signedUrl)
            callback(blobUrl, data.fileType)
        }
        else callback(data.signedUrl, data.fileType)
    }
    else {
        const url = `/file/download-attachment?key=${key}&fileName=${fileName}`;

        const response = await GET(url);
        if (!response.data) {
            throw new Error('Network response was not ok');
        }
        let data = response.data.message
        callback(data.signedUrl, data.fileType)
    }

}

export const getFileDetailsFromOneDriveUrl = async (fileUrl) => {
    let response = await POST(`/onedrive/getFileDetailsFromUrl`, { fileUrl });
    return response.data
}

export const getAndStoreSharedListsInStore = (userData) => async(dispatch) =>{ 
    const result = await POST(`${ELASTIC_URL}/shared-list/getSharedLists`,{user_email : userData.email}) ;
    if(result && result.data){
        const sharedLists = result.data ; 
        dispatch(setSharedListsInStore(sharedLists)) ;
    }
    
}

export const setNotificationAccessFlag = (isNotificationAccessReceived) => async(dispatch) => {
    dispatch({type : ACTION_TYPES.SET_NOTIFICATION_DATA , isNotificationAccessReceived: isNotificationAccessReceived });
}

export const setLastUsedSheetInDB = () => async (dispatch) => {
    try {

        const { isUserActivityAlreadyInDb } = store.getState().userActivityReducer;
        const { user } = store.getState().userReducer;
        const { currentSelectedSheet } = store.getState().sheetReducer;
        
        const activityObject = createUserActivityTemplate(user, currentSelectedSheet);

        if(isUserActivityAlreadyInDb){
            await PATCH(`/user-activity/setlastusedsheet`, activityObject)
        }else{
            const resp = await getLastUsedSheetFromDB();
            if (Object.keys(resp).length === 0) {
                await POST(`/user-activity/setlastusedsheet`, activityObject);
            } else {
                await PATCH(`/user-activity/setlastusedsheet`, activityObject)
            }
        }
        if(!isUserActivityAlreadyInDb) dispatch(setIsUserActivityAlreadyInDbInStore(true))

    } catch (error) {
        console.error("Error in setLastUsedSheetInDB", error);
    }
}


export const getLastUsedSheetFromDB = async() => {
    try {
        const { user } = store.getState().userReducer;
        const resp = await GET(`/user-activity/${user}`);
        return resp.data;
    } catch (error) {
        console.log("Error in getLastUsedSheetFromDB",error);
    }
}

export const setIsUserActivityAlreadyInDbInStore = (isAvailable) => async (dispatch) => {
    try {
        dispatch({ type: ACTION_TYPES.SET_ISUSERACTIVITYALREADYINDB, isUserActivityAlreadyInDb: isAvailable })
    } catch (error) {
        console.log("Error in setIsUserActivityAlreadyInDbInStore", error);
    }
}

export const setischeckInAgentRowsToBeMergedInStore = (ischeckInAgentRowsToBeMerged )=> async(dispatch) =>{
    try {
        dispatch({ type: ACTION_TYPES.SET_IS_CHECKINAGENT_ROWS_TO_BE_MERGED, ischeckInAgentRowsToBeMerged: ischeckInAgentRowsToBeMerged })
    } catch (error) {
        console.log("Error in setischeckInAgentRowsToBeMergedInStore", error);
    }
}

export const setIsOneDriveServiceWorking = (isOnedriveWorking) => (dispatch) => {
    const {isOneDriveConnected} = store.getState().userActivityReducer;
    if(!isOnedriveWorking && isOneDriveConnected){
        oneDriveLogout()
        dispatch({type:ACTION_TYPES.SET_USER_ACTIVITY_INFO,isOneDriveConnected:false,backupAllWorkbookstoOneDrive:false})
        renderAlert("The OneDrive connection has been lost. Please try again later.", "info");
    }
    dispatch({
        type: ACTION_TYPES.SET_ISONEDRIVESERVICEWORKING,
        isOneDriveServiceWorking: isOnedriveWorking
    });
};


export const setTriggerSave = (triggerSave )=> async(dispatch) =>{
    try {
        dispatch({ type: ACTION_TYPES.SET_TRIGGERSAVE, triggerSaveExternally: triggerSave })
    } catch (error) {
        console.log("Error in setTriggerSave", error);
    }
}

export const hasOriginalTemplateShareAccessForInstance = (currentSelectedSheet)=> async (dispatch) => {
    const {isShared} = store.getState().sheetReducer;
    const {isSharedWorkbook} = store.getState().workbookReducer;
    if(!isShared && !isSharedWorkbook && currentSelectedSheet.template_id && currentSelectedSheet.hasOriginalTemplatesharedWithUser === undefined){
    
    const {templateTree } = store.getState().workspaceReducer;
    const {userData} = store.getState().userReducer;
    const originalTemplate = templateTree?.find(
    t => t.template_id === currentSelectedSheet?.template_id && t.l_id.includes("sharedTemplates")
  );

    if (!originalTemplate) {
        dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, hasOriginalTemplateShareAccess: false })
        await POST(`${ELASTIC_URL}/sheet/update`, {
            sheetId: currentSelectedSheet.id,
            doc: {
                hasOriginalTemplatesharedWithUser: false
            }
        });
        return;
    };

  const res = await POST(`/access/getAccessByEntityId/`, { 
      entity_id: originalTemplate.workbook_id
  });

    const hasOriginalTemplateShareAccess = res?.data?.some(a => a.user_id === userData?.email);
    await POST(`${ELASTIC_URL}/sheet/update`, {
        sheetId: currentSelectedSheet.id,
        doc: {
            hasOriginalTemplatesharedWithUser: hasOriginalTemplateShareAccess
        }
    });
   dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, hasOriginalTemplateShareAccess: hasOriginalTemplateShareAccess})
    }
};

export const disconnectAzureDevOps = () => async(dispatch) => { 
    try {
        dispatch({
            type: ACTION_TYPES.SET_ISAZUREDEVOPS_CONNECTED,
            isAzureDevOpsConnected: false,
        });
    } catch (error) {
        console.error("Error in disconnectAzureDevOps", error);
        
    }
}